import AuthService from '@/services/AuthService'
import i18n from '@/plugins/i18n'
import * as types from './mutations-type.js'

export default {
  loadingON({ commit, state }) {
    commit(types.SET_LOADING_ON, true)
  },
  loadingOFF({ commit }) {
    commit(types.SET_LOADING_OFF, false)
  },
  async login({ dispatch, commit, state }, toast) {
    dispatch('loadingON')
    await AuthService.login(state.credentials)
      .then((resp) => {
        commit(types.LOGIN, [resp.data, toast])
      })
      .catch(() => {
        toast.error(i18n.t('auth.notification.loginError'), 'ERROR', {
          queueable: true,
        })
      })
    dispatch('loadingOFF')
  },
  logout({ commit }, [toast, message]) {
    commit(types.LOGOUT)
    if (message) {
      toast.success(i18n.t('auth.notification.logout'), {
        queueable: true,
        color: '#37A98C',
      })
    }
  },
  async refresh({ commit }, [refresh_token, token]) {
    const { data } = await AuthService.refreshToken(refresh_token, token)
    commit(types.REFRESH, data)
  },
}
